import { render } from "./Profile.vue?vue&type=template&id=5bc358aa&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=5bc358aa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5bc358aa"

export default script